import { ChatBubble, Drawer, HeadingRow } from "cai-fusion"
import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";

import { useSiftV2 } from "../../../contexts/siftV2Context"

import { ReactComponent as IconCloseSquare } from "../../../../../images/close-square.svg";
// import ChatComposer from "../../../../fusion/Chat/ChatComposer";

const avatarAI = require("../../../../../images/avatar-ai-classic.png");

const EditOpportunityOverviewDrawer = () => {
    const { visibilityStates, hide } = useTransientVisibility();
    const { placeholderEditChat } = useSiftV2();

    return (
        <Drawer
            clickOutsideToClose
            isHidden={!visibilityStates.EditOpportunityOverviewDrawer}
            onClose={(e) => {
                hide('EditOpportunityOverviewDrawer');
                e.preventDefault();
            }}
            placement="right"
            eyebrow="Opportunity Details"
            header={
                <HeadingRow
                    title="Comment History"
                    eyebrow="Opportunity Details"
                    size={3}
                >
                    <div className="m-icon-row m-icon-row--right-align">
                        <a
                            id="drawerCloseBtn"
                            className="a-icon m-icon-row__icon"
                            title="Close Associate Details"
                            onClick={(e) => {
                                hide('OpportunityDiscussionDrawer');
                                e.preventDefault();
                            }}
                        >
                            <IconCloseSquare className="a-icon__img" />
                        </a>
                    </div>
                </HeadingRow>
            }
        >
            <div className="row">
                <div className="col-md-12">
                    <div className="o-chat">
                        {placeholderEditChat.map((message) => (
                            <ChatBubble 
                                isAssistant={message.isAI}
                                isReply={message.name !== "You"}
                                name={message.name}
                                dateTime={message.time}
                                children={message.message}
                                image={<img src={avatarAI} className="a-avatar__img a-avatar__img--square" /> }
                            />
                        ))}
                    </div>
                    <div className="o-drawer__fixed-element">
                        {/* <ChatComposer /> */}
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default EditOpportunityOverviewDrawer;